module.exports = __webpack_public_path__ + "static/assets/9d9821257798cd7239b14d8ba5227aaa.svg";